import React, { useState } from "react";
import Instance from "../../Services/Instance";
import config from "../../Services/config";
import SideBar from "../../Layouts/SideBar";
import { useParams } from "react-router-dom";
import "../../Assets/Styles/Products.css";

function AddPromo() {
    const { id } = useParams();
    const [error, setError] = useState("");

    const [promo, setPromo] = useState({
        promoType: "",
        promoMode: "", // 👈 reduction | price
        pourcentagePromo: "",
        productPricePromo: "",
        codePromo: "",
        validity: ""
    });

    const onChange = (e) => {
        const { name, value } = e.target;
        setPromo((prev) => ({ ...prev, [name]: value }));
    };

    // 🧼 PAYLOAD CLEAN
    const buildPayload = () => {
        const payload = {
            promoType: promo.promoType,
            validity: promo.validity
        };

        if (promo.promoMode === "reduction") {
            payload.pourcentagePromo = Number(promo.pourcentagePromo);
        }

        if (promo.promoMode === "price") {
            payload.productPricePromo = Number(promo.productPricePromo);
        }

        if (promo.promoType === "With_Code" && promo.codePromo.trim()) {
            payload.codePromo = promo.codePromo.trim();
        }

        return payload;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        const payload = buildPayload();
        console.log("Promo envoyée :", payload);

        try {
            await Instance.patch(
                `${config.api_url}/product/add-promo/${id}`,
                payload
            );

            alert("Promotion ajoutée avec succès");
            window.location = "/dashboard/product";
        } catch (err) {
            console.error("Erreur ajout promo :", err);
            setError(
                err.response?.data?.message ||
                "Erreur lors de l'ajout de la promotion"
            );
        }
    };
console.log("Current promo state:", promo);
    return (
        <div className="a-new-product">
            <SideBar />

            <div className="parent-new-product">
                <form onSubmit={handleSubmit} className="new-product custom-layout-product">
                    <div className="form-display">

                        {/* MODE DE PROMO */}
                        <div>
                            <label>Comment appliquer la promotion ?</label>
                            <select
                                className="input"
                                name="promoMode"
                                value={promo.promoMode}
                                onChange={onChange}
                                required
                            >
                                <option value="">Sélectionner</option>
                                <option value="reduction">Par réduction (%)</option>
                                <option value="price">Par prix du promo </option>
                            </select>
                        </div>

                        {/* POURCENTAGE */}
                        {promo.promoMode === "reduction" && (
                            <div>
                                <label>Pourcentage de réduction (%)</label>
                                <input
                                    type="number"
                                    className="input"
                                    name="pourcentagePromo"
                                    min="1"
                                    max="100"
                                    value={promo.pourcentagePromo}
                                    onChange={onChange}
                                    required
                                />
                            </div>
                        )}

                        {/* PRIX PROMO */}
                        {promo.promoMode === "price" && (
                            <div>
                                <label>Prix du produit en promo</label>
                                <input
                                    type="number"
                                    className="input"
                                    name="productPricePromo"
                                    min="0"
                                    value={promo.productPricePromo}
                                    onChange={onChange}
                                    required
                                />
                            </div>
                        )}


                        {/* TYPE DE PROMO */}
                        <div>
                            <label>Type de promo</label>
                            <select
                                className="input"
                                name="promoType"
                                value={promo.promoType}
                                onChange={onChange}
                                required
                            >
                                <option value="">Sélectionner</option>
                                <option value="Direct">Direct</option>
                                <option value="With_Code">Avec Code</option>
                            </select>
                        </div>
                        
                        {/* CODE PROMO */}
                        {promo.promoType === "With_Code" && (
                            <div>
                                <label>Code promo</label>
                                <input
                                    type="text"
                                    className="input"
                                    name="codePromo"
                                    value={promo.codePromo}
                                    onChange={onChange}
                                    required
                                />
                            </div>
                        )}

                        {/* VALIDITÉ */}
                        <div>
                            <label>Date de validité</label>
                            <input
                                type="date"
                                className="input"
                                name="validity"
                                value={promo.validity}
                                onChange={onChange}
                                required
                            />
                        </div>
                    </div>

                    <div className="validate">
                        <button type="submit" className="add-new-element">
                            Ajouter Promotion
                        </button>
                    </div>
                </form>
            </div>

            {error && (
                <p style={{ color: "red", position: "fixed", bottom: 20, left: "10%" }}>
                    {error}
                </p>
            )}
        </div>
    );
}

export default AddPromo;
